module.exports = __webpack_public_path__ + "img/icon_heart_full.ee6ea806.svg";